var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageSpeakerMute = function SvgImageSpeakerMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m22.168 7.691 3.883 3.883 3.883-3.883L32 9.759l-3.882 3.883 3.881 3.878-2.07 2.07-3.878-3.88-3.883 3.882-2.069-2.067 3.883-3.883-3.883-3.883zM17.052 0v27.281L7.229 19.04H0V8.242h7.23z"
  })));
};
export { SvgImageSpeakerMute as ReactComponent };
export default __webpack_public_path__ + "assets/ImageSpeakerMute.3b13f9a7365e91ff16213b6da417187f.svg";